import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';

// This was mostly copied from react-router docs https://reactrouter.com/en/main/start/faq#what-happened-to-withrouter-i-need-it
// But, their version was passing all of the props in as a single `router={{ location, navigate, params }}` prop,
// and that's not how our previous `withRouter` props were being passed. I have tweaked it to work with the style we have.
export function withRouter(Component) {
    const ComponentWithRouterProp = (props) => {
        const location = useLocation();
        const navigate = useNavigate();
        const params = useParams();

        const match = { params };

        return (
            <Component
                {...props}
                location={location}
                navigate={navigate}
                match={match}
            />
        );
    };

    return ComponentWithRouterProp;
}
